import { render, staticRenderFns } from "./CardPrebiotic.vue?vue&type=template&id=05b89576&scoped=true&"
import script from "./CardPrebiotic.vue?vue&type=script&lang=js&"
export * from "./CardPrebiotic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b89576",
  null
  
)

export default component.exports